import { create } from 'zustand';

type PayfurlData = {
    submissionId: string;
}

interface PayfurlContext {
    submissionId: string;
    setPayfurlData: (props: PayfurlData) => void;
}

export const usePayfurlContext = create<PayfurlContext>(set => {
    return {
        submissionId: '',
        setPayfurlData: (params): void => {
            set({ ...params });
        },
    };
});
